module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/schwab.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/schwab.png
// module id = 1178
// module chunks = 0